//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-318575 - Remove once feature is released
export const getIsContentSupplyChainEnabled = createHasFeatureSelector(
  FeatureNames.InsightsContentSupplyChainReporting,
);
